<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" />
      </template>
    </template>
    <main class="common-main">
      <div class="item" style="text-align: center; margin: 100px 0">
        <h2 class="common-title">指定されたURLは存在しませんでした</h2>
        <div class="item">
        URLが正しく入力されていないか、このページが削除された可能性があります
        </div>
      </div>
    </main>
    <FooterItem :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { Analytics/*, Logger*/ } from "aws-amplify"
import HeaderItem from './Header'
import FooterItem from './Footer'

//const logger = new Logger('NotFound');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'notfound',
  components: {
    HeaderItem,
    FooterItem
  },
  data() {
    return {
    }
  },
  async beforeCreate() {
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'NotFound',
        url: window.location.origin + window.location.pathname
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/notFound',
        page_title: '404 (/notFound)'
      })
    }
  }
}
</script>
